import theme from '../../../../../lib/theme';
import { BreakdownBlockProps } from './BreakdownBlock';

const { layouts, scale, media } = theme;

export default ({ block: { imageURL } }: BreakdownBlockProps) => ({
  panel: {
    ...layouts.panel,

    maxWidth: '100vw',
    overflow: 'hidden',
    position: 'relative',
  },

  container: {
    ...layouts.container('l'),
    ...layouts.spacedColumn('l'),
  },

  headings: {
    ...layouts.spacedColumn('xs'),

    width: '100%',
    maxWidth: 903,
  },

  breakdowns: {
    ...layouts.row,

    flexWrap: 'wrap',
    alignItems: 'flex-start',
  },

  breakdown: {
    width: 300,
    marginRight: scale.s,
    marginBottom: scale.s,

    [media.m.up]: {
      marginBottom: scale.l,
    },
  },

  image: {
    display: imageURL ? 'block' : 'none',
    width: '100%',
    height: 225,

    '&:after': {
      content: `' '`,
      position: 'absolute',
      left: 0,
      right: 0,
      height: 225,
      backgroundRepeat: 'repeat-x',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundImage: `url('${imageURL}')`,
    },
  },
});
